<template>
  <FooterPageLayout v-model:selectedListItemIndexFromProps="selectedListItemIndex" :pageData="refundPageData">
    <div class="wd-my-6 <xs:wd-mx-5 <xs:wd-mb-9" v-html="$t('refund_policy_content')" />
  </FooterPageLayout>
</template>

<script lang="ts" setup>
import FooterPageLayout from '@/components/FooterPageLayout.vue'

defineOptions({
  name: 'TermsRefundPage',
})

const nuxtApp = useNuxtApp()
const { $i18n } = nuxtApp
const route = useRoute()

const selectedListItemIndex = ref(0)

const refundPageData = computed(() => ({
  title: $i18n.t('footer_refund_policy'),
  list: [
    {
      text: $i18n.t('footer_user_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-consumer',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_private_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-privacy',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_refund_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-refund',
        query: route.query,
      }),
    },
    ...($i18n.locale.value === 'ja'
      ? [
          {
            text: $i18n.t('footer_japan_term'),
            localePath: nuxtApp.$localePath({
              name: 'terms-law',
              query: route.query,
            }),
          },
        ]
      : []),
  ],
}))

onMounted(() => {
  const defaultSelectedIndex = refundPageData.value.list.findIndex(item => item.localePath.includes('/terms/refund'))
  selectedListItemIndex.value = defaultSelectedIndex
})
</script>
